import { createAction } from 'utils/redux';

export const receiveSentryConfig = (payload: {forceLog:boolean, limit:number}) => createAction({
  type: 'RECEIVE_SENTRY_CONFIG',
  payload
})
